// eslint-disable-next-line jira/import-whitelist
import { DefaultFilterFields } from '@atlassian/jira-directory-base-v3/src/controllers/create-use-filter/index.tsx';

export const TableColumns = {
	Favourites: 'favourite',
	Key: 'key',
	Name: 'name',
	Type: 'type',
	Lead: 'lead',
	Category: 'category',
	LastIssueUpdate: 'last_issue_updated_time',
	Url: 'url',
	Action: 'actions',
} as const;

export type TableColumns = (typeof TableColumns)[keyof typeof TableColumns];

export const SortableColumns: TableColumns[] = [
	TableColumns.Favourites,
	TableColumns.Key,
	TableColumns.Name,
	TableColumns.Lead,
	TableColumns.Category,
	TableColumns.LastIssueUpdate,
];

export const FilterFields = {
	Keyword: 'keyword',
	ProjectType: 'types',
	ProjectTypeLabel: 'ProjectTypeLabel',
	ProjectCategoryId: 'projectCategoryId',
	ProjectCategoryLabel: 'projectCategoryLabel',
	...DefaultFilterFields,
};

export const filterAliasMap = {
	contains: FilterFields.Keyword,
	selectedProjectType: FilterFields.ProjectType,
	selectedCategory: FilterFields.ProjectCategoryId,
};

export const filterInitialState = {
	[FilterFields.Keyword]: '',
	[FilterFields.ProjectType]: '',
	[FilterFields.ProjectTypeLabel]: '',
	[FilterFields.ProjectCategoryId]: '',
	[FilterFields.ProjectCategoryLabel]: '',
	[FilterFields.SortOrder]: 'ASC',
	[FilterFields.SortKey]: TableColumns.Name,
	[FilterFields.Page]: '1',
};

export const filterInitialStateSortExp = {
	[FilterFields.Keyword]: '',
	[FilterFields.ProjectType]: '',
	[FilterFields.ProjectTypeLabel]: '',
	[FilterFields.ProjectCategoryId]: '',
	[FilterFields.ProjectCategoryLabel]: '',
	[FilterFields.SortOrder]: 'DESC',
	[FilterFields.SortKey]: 'recommendation', // special sort key that is not associate with a table column to sort by recommendation.
	[FilterFields.Page]: '1',
};

export type FilterInitialState = typeof filterInitialState;

export const DEFAULT_LIMIT = 25;

export const PROJECTS_DIRECTORY_EXPERIENCE = 'viewProjectsDirectoryV3';
export const MANAGE_PROJECTS_DIRECTORY_EXPERIENCE = 'viewManageProjectsDirectoryV3';
